//
//
//
//
//
//
//

export default {
  name: 'ui-radio',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      require: true
    },
    model: {
      type: [String, Number, Boolean],
      require: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.checked === true) this.updateVal()
  },
  methods: {
    updateVal () {
      this.$emit('change', this.value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiRadio.vue